import { Cross } from "@vnmfify/icons"
import { cloneIconElement } from "@vnmfify/icons/utils"
import { View } from "@vnxjs/components"
import { ViewProps } from "@vnxjs/components/types/View"
import classNames from "classnames"
import * as React from "react"
import { ReactNode } from "react"
import { prefixClassname } from "../styles"

interface UploaderRemoveProps extends ViewProps {
  className?: string
  icon?: ReactNode
}

function UploaderRemove(props: UploaderRemoveProps) {
  const { className, icon = <Cross />, ...restProps } = props

  return (
    <View
      className={classNames(prefixClassname("uploader__preview-remove"), className)}
      {...restProps}
    >
      {cloneIconElement(icon, { className: prefixClassname("uploader__preview-remove-icon") })}
    </View>
  )
}

export default UploaderRemove
